import AdvancedController from "../lib/advanced-controller"
import { gsap } from 'gsap';
// import ScrollTrigger from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

export default class Scene02Controller extends AdvancedController {

  static targets = [
    "container",
    "slider",
    "slide",
    "slide01Content",
    "slide02Content",
    "slide03Content",
    "slideContent",
    "img01",
    "img02",
    "img03"
  ];

  static values = {
    streams: Array
  }

  connect() {
    super.connect();

    const streamIndex = 1
    const streamValue = this.streamsValue[streamIndex];

    for (let i = 1; i <= 3; i++) {
      const element = this[`img0${i}Target`];
      const srcString = streamValue[i] + (window.innerWidth < 768 ? '-sm' : '') + '.webp';
      element.setAttribute('src', srcString);
    }

    const BASE_ANIMATION_TIME = 3;

    this.timeline = gsap.timeline({

      onUpdate: this.onUpdate.bind(this),
      scrollTrigger: {
        // trigger: this.containerTarget,
        start: "-64px top",
        pin: this.containerTarget,
        end: "600%",
        scrub: 0.5,
        // markers: { startColor: "green", endColor: "red", fontSize: "12px" }
      }
    });

    let totalWidth = 0;
    for (const slideTarget of this.slideTargets) {
      totalWidth += slideTarget.offsetWidth
    }
    const slidePercent = (totalWidth - this.sliderTarget.offsetWidth) / this.sliderTarget.offsetWidth * 100

    const steps = [
      { el: document.body, to: { opacity: 1, duration: 0.5 * BASE_ANIMATION_TIME } },
      { el: this.sliderTarget, to: { x: `-=${slidePercent}%`, ease: 'none', duration: BASE_ANIMATION_TIME * 3 } },
    ]

    let i = 0;
    for (const slideContent of this.slideContentTargets) {
      steps.push({ el: slideContent, to: { opacity: 1, duration: 0.5 * BASE_ANIMATION_TIME }, offset: i * BASE_ANIMATION_TIME })
      i += 1;
    }

    steps.push({ el: document.body, to: { opacity: 1, duration: BASE_ANIMATION_TIME * 0.5 } })

    for (const step of steps) {
      this.timeline.to.apply(this.timeline, [step.el, step.to, step.offset])
    }
  }

  onUpdate() {
    this.sendMessage(this.debugController, 'messageProgress', this.timeline.progress())
  }

  messageDebugInit(debugController) {
    this.debugController = debugController
    this.hasDebugController = true
  }

  messageProgress(progress) {
    this.timeline.pause();
    this.timeline.progress(progress)
  }

  messageTogglePlayPause() {
    if (this.timeline.paused()) {
      this.timeline.play();
    } else {
      this.timeline.pause();
    }
  }

}
